import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { createRequestOption } from '../../model/request-util';
import { SERVER_API_URL } from '../../../environment.constants';
import { EnableLoadingIndicator, EnableSavingIndicator } from '../../loading-indicator';
import { ParamContext } from '../../service/param.context';
import { PropertySearchRequest } from '../model/property-search-request.model';
import { PropertyDetails } from '../model/property-details';

@Injectable()
export class PropertyService {

    constructor(
        private http: HttpClient,
        private paramContext: ParamContext
    ) {
    }

    getProperties(): Observable<PropertyDetails[]> {
        const url = SERVER_API_URL + `crops/${this.paramContext.cropName}/properties?programUUID=${this.paramContext.programUUID}`;
        return this.http.get<PropertyDetails[]>(url, { context: new HttpContext().set(EnableLoadingIndicator, true) });
    }

    queryProperties(query: string): Observable<HttpResponse<PropertyDetails[]>> {
        return this.http.get<PropertyDetails[]>(SERVER_API_URL + `crops/${this.paramContext.cropName}/properties/search?query=` + query, { observe: 'response' });
    }

    searchProperties(search: PropertySearchRequest, req: any): Observable<HttpResponse<PropertyDetails[]>> {
        const params = createRequestOption(req);
        const url = SERVER_API_URL + `crops/${this.paramContext.cropName}/properties/search`;
        return this.http.post<PropertyDetails[]>(url, search, {
            params,
            observe: 'response', context: new HttpContext().set(EnableLoadingIndicator, true)
        });
    }

    getPropertyId(propertyId: string): Observable<PropertyDetails> {
        const url = SERVER_API_URL + `crops/${this.paramContext.cropName}/properties/${propertyId}?programUUID=${this.paramContext.programUUID}`;
        return this.http.get<PropertyDetails>(url, { context: new HttpContext().set(EnableLoadingIndicator, true) });
    }

    update(property: PropertyDetails): Observable<HttpResponse<PropertyDetails>> {
        const url = SERVER_API_URL + `crops/${this.paramContext.cropName}/properties/${property.id}?programUUID=${this.paramContext.programUUID}`;
        return this.http.put<PropertyDetails>(url, property, { observe: 'response', context: new HttpContext().set(EnableSavingIndicator, true) });
    }

    create(property: PropertyDetails): Observable<HttpResponse<{ id: string }>> {
        const url = SERVER_API_URL + `crops/${this.paramContext.cropName}/properties?programUUID=${this.paramContext.programUUID}`;
        return this.http.post<{ id: string }>(url, property, { observe: 'response', context: new HttpContext().set(EnableSavingIndicator, true) });
    }

    delete(propertyId: string): Observable<HttpResponse<any>> {
        const url = SERVER_API_URL + `crops/${this.paramContext.cropName}/properties/${propertyId}?programUUID=${this.paramContext.programUUID}`;
        return this.http.delete<any>(url, { observe: 'response', context: new HttpContext().set(EnableSavingIndicator, true) });
    }
}
